// extracted by mini-css-extract-plugin
export default {"terms":"Terms_terms__vezMi","header":"Terms_header__9Yplo"};